import { CircleCheck, FileSearch } from "lucide-react";

export default function LoanEligibility({
  badge,
  title,
  description,
  requirements = [],
  approvalFactors = [],
  cta,
  onCheckEligibility,
}) {
  return (
    <section id="eligibility" className="py-20 bg-slate-50">
      <div className="container mx-auto px-6">
        <div className="text-center max-w-3xl mx-auto">
          <span className="text-primary font-semibold uppercase tracking-wider">
            {badge}
          </span>

          <h2 className="mt-3 text-3xl md:text-4xl font-bold">{title}</h2>

          <p className="mt-5 text-lg text-slate-600 leading-8">{description}</p>
        </div>

        <div className="grid lg:grid-cols-2 gap-10 mt-16">
          <div className="bg-white rounded-2xl border p-8">
            <h3 className="text-2xl font-semibold mb-8">Basic Eligibility</h3>

            <div className="space-y-6">
              {requirements.map((item) => {
                const Icon = item.icon;

                return (
                  <div key={item.title} className="flex items-start gap-4">
                    <div className="min-w-12 w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center text-primary">
                      <Icon className="w-6 h-6" />
                    </div>

                    <div>
                      <div className="font-semibold">{item.title}</div>

                      <div className="text-slate-600 mt-1">{item.value}</div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          <div className="bg-primary rounded-2xl p-8 text-white">
            <div className="flex items-center gap-3">
              <FileSearch className="w-8 h-8" />

              <h3 className="text-2xl font-semibold">
                Factors That Affect Approval
              </h3>
            </div>

            <div className="mt-8 space-y-5">
              {approvalFactors.map((factor) => (
                <div key={factor} className="flex items-start gap-3">
                  <CircleCheck className="w-5 h-5 mt-1 shrink-0" />

                  <span className="text-primary-foreground/90">{factor}</span>
                </div>
              ))}
            </div>

            <div className="mt-10 rounded-xl bg-white/10 p-6">
              <h4 className="font-semibold text-lg">{cta.title}</h4>

              <p className="mt-3 text-primary-foreground/80 leading-7">
                {cta.description}
              </p>

              <button
                onClick={onCheckEligibility}
                className="mt-6 bg-white text-primary px-6 py-3 rounded-lg font-semibold hover:bg-slate-100 transition"
              >
                {cta.buttonText}
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
